import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=92778d20&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.vue?vue&type=style&index=0&id=92778d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92778d20",
  null
  
)

export default component.exports